// export const API_URL = 'http://localhost/liceo_morelia/ce/api';
export const API_URL = 'https://ce.liceomorelia.mx/api';
